import axios from '@/libs/api.request'

export const getSeriesList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/series'
  })
}

export const getSeriesTemplate = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/series/excel'
  })
}

export const addSeries = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/series'
  })
}

export const editSeries = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/series'
  })
}

export const delSeries = (id) => {
  return axios.request({
    method: 'delete',
    url: '/series/' + id
  })
}

export const batchDelSeries = (data) => {
  return axios.request({
    method: 'delete',
    data,
    url: '/series/batch'
  })
}

export const getSeriesInfo = (id) => {
  return axios.request({
    method: 'get',
    url: '/series/' + id
  })
}


// 改版后获取
export const getEpisodesList = (data) => {
  return axios.request({
    method: 'post',
    url: 'play/video/task/list',
    data
  })
}

export const confirmVideoList = (data) => {
  return axios.request({
    method: 'post',
    url: 'play/video/conform/list',
    data
  })
}

export const videoUpload = (data) => {
  return axios.request({
    method: 'post',
    url: 'play/video/upload',
    data
  })
}

export const cancelTask = (data) => {
  return axios.request({
    method: 'post',
    url: 'play/video/upload/cancel',
    data
  })
}

export const uploadSaveCheck = (data) => {
  return axios.request({
    method: 'post',
    url: 'play/video/upload/save/check',
    data
  })
}

export const uploadSave = (data) => {
  return axios.request({
    method: 'post',
    url: 'play/video/upload/save',
    data
  })
}

export const uploadSingleFile = (params,data,cancelToken) => {
  return axios.request({
    method: 'post',
    url: '/play/video/single/upload',
    params,
    data,
    ...cancelToken
  })
}